module.exports = __webpack_public_path__ + "img/Pic_XYZX_ZHYEY.ee79198e.png";